module.exports = __webpack_public_path__ + "img/plus-1.7deeb6b8.svg";